/**
 * 404 — a pause rather than a fault.
 *
 * The mark is a butter lamp resting in a lotus: the path is lost, the light is
 * not. It replaces the `EmptyState` compass this page used to borrow, because
 * an empty list and a wrong address are not the same event and should not
 * arrive with the same picture.
 */
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LampMark from '../components/LampMark';
import { trackEvent } from '../lib/consent';

export default function NotFound() {
  const { t } = useTranslation();

  // The pageview for this route still fires from AnalyticsPageview; this adds
  // a distinct signal with the path that missed, so dead links and bad
  // inbound URLs are findable in the reports rather than buried in pageviews.
  useEffect(() => {
    trackEvent('page_not_found', { path: window.location.pathname + window.location.search });
  }, []);

  return (
    <div className="shell lost">
      <LampMark className="lost__mark" />

      <h1 className="display display--md lost__title">
        {t('notFound.title', 'The path ends here')}
      </h1>

      <p className="lost__body">
        <span>{t('notFound.body', 'The page you’re looking for could not be found.')}</span>
        <span>{t('notFound.onward', 'Let’s find another way forward.')}</span>
      </p>

      <Link to="/" className="btn btn--gold btn--lg">
        {t('notFound.backHome', 'Return to GOMPA')}
      </Link>
    </div>
  );
}
